import { useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// formik components
import { useFormikContext } from "formik";

// Material Dashboard 2 PRO React TS components
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

import FormField from "components/FormField";
import FormSelect from "components/FormSelect";

import { useFormPrevProjContext } from "contexts/contextFormPrevProj";

function PeriodForm({ formData }: any): JSX.Element {
  const { formField, values, errors, touched } = formData;
  const { country, startPeriodYear, lastPeriodYear, periodYearStep } = formField;

  const { setLocCode } = useFormPrevProjContext();
  const { values: v } = useFormikContext<any>();

  useEffect(() => {
    if (v?.locCode) setLocCode(v?.locCode);
  }, [v?.locCode]);

  return (
    <MDBox bgColor="white" borderRadius="sm" sx={{ boxShadow: 1 }}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h5">Country:</MDTypography>
        </Grid>
        <Grid item xs={12}>
          <FormSelect
            label={country.label}
            name={country.name}
            options={country.options}
            value={values.locCode}
            error={errors.locCode && touched.locCode}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h5">Starting Year:</MDTypography>
        </Grid>
        <Grid item xs={12}>
          <FormField
            disabled={true}
            formatted={false}
            label={startPeriodYear.label}
            name={startPeriodYear.name}
            options={startPeriodYear.options}
            value={values.startPeriodYear}
            error={errors.startPeriodYear && touched.startPeriodYear}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h5">Last Year:</MDTypography>
        </Grid>
        <Grid item xs={12}>
          <FormSelect
            label={lastPeriodYear.label}
            name={lastPeriodYear.name}
            options={lastPeriodYear.options}
            value={values.lastPeriodYear}
            error={errors.lastPeriodYear && touched.lastPeriodYear}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h5">Period coverage (years):</MDTypography>
        </Grid>
        <Grid item xs={12}>
          <FormSelect
            label={periodYearStep.label}
            name={periodYearStep.name}
            options={periodYearStep.options}
            value={values.periodYearStep}
            error={errors.periodYearStep && touched.periodYearStep}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default PeriodForm;
